import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplyV2Config {
  apiUrl = '';
  envName = '';
  ownerLoginUrl? = '';
  isPrequalificationApp? = false;
  customHeaders?: {
    [key: string]: string;
  };
}
